module.exports = __webpack_public_path__ + "static/media/4-iron.cb13fb54.png";